export default __webpack_public_path__ + "static/media/Earnings-Call-Transcript-Q1FY27.7307e0f6.pdf";